const ValidationError = ({ error }) => {
    return error ? <span style={{color:'red'}} className="validation-error">{error.message}</span> : null;
};

export default ValidationError;
